import Certification from './Certification';

export default Certification;
